import * as React from 'react';
import { Spinner } from 'react-bootstrap';

export default class NovedadesDeLiquidacion extends React.Component {

    render = () => {

        const novedades = this.props.novedades;

        return (

            this.props.isLoading ?

            <div className="d-flex justify-content-center">
                <Spinner animation="border" variant="secondary" size="lg-centrado" role="status">
                    <span className="sr-only">Loading...</span>
                </Spinner>
            </div>

            :

            novedades.length > 0 ?

            <div className="row justify-content-center align-items-center p-10">

                <h5 className="col-auto">Novedades</h5>

                <div className="list-group-item col-12 animated fadeIn">
                    <div className="table-responsive card">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Orden Ref</th>
                                    <th scope="col">Tipo</th>
                                    <th scope="col">Fecha</th>
                                    <th scope="col">Importe</th>
                                    <th scope="col">Acción</th>
                                </tr>
                            </thead>
                            <tbody>
                            {
                                novedades.map((novedad, i) => {
                                    return (
                                        <tr key={i} className="hover-background-color">
                                            <td><span>{i + 1}</span></td>
                                            <td><span>{novedad.ordenDeReferencia}</span></td>
                                            <td><span>{novedad.tipoNovedadDescripcion}</span></td>
                                            <td><span>{novedad.fechaNovedadMostrar}</span></td>
                                            <td><span>{novedad.importeNovedad}</span></td>
                                            <td><span>{novedad.descripcionSubTipoNovedad}</span></td>
                                        </tr>
                                    )
                                })
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            :
            
            <div className="card">
                <div className="card-body">
                    <div className="row justify-content-center align-items-center p-10">
                        No hay novedades para esta liquidación
                    </div>
                </div>
            </div>
        );
    }
}